import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

export default function DialogWithMessage(props) {
    function handleOK() {
        props.onClose(false);
    }

    return (
        <Dialog
            onClose={handleOK}
            aria-labelledby="message-dialog-title"
            open={props.open}
            fullWidth
            maxWidth="xs"
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        overflow: "hidden",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "primary.main",
                        backgroundColor: "action.hover",
                    }}
                >
                    <InfoOutlinedIcon />
                </Box>
                <Typography
                    id="message-dialog-title"
                    variant="h5"
                    component="h2"
                    sx={{ flex: 1, minWidth: 0, lineHeight: 1.1 }}
                >
                    {props.title}
                </Typography>
                <IconButton
                    aria-label="Close message"
                    onClick={handleOK}
                    sx={{ mt: -0.75, mr: -1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent
                dividers
                sx={{
                    p: { xs: 2, sm: 2.5 },
                    backgroundColor: "background.default",
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        borderRadius: 2.5,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                    }}
                >
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ lineHeight: 1.6 }}
                    >
                        {props.message}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
                <Button
                    onClick={handleOK}
                    variant="contained"
                    disableElevation
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
